import axios from 'axios'

const request = axios.create({
    baseURL: process.env.VUE_APP_URL_BASE,
    timeout: 30000
});

request.interceptors.request.use(
    config => {
        // console.group('全局请求拦截');
        // console.log(config.url);
        // console.groupEnd();

        // if (config.url) {
        //     // 携带token
        //     let token = localStorage.getItem('token');
        //     token && (config.headers.Authorization = token);
        // }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

request.interceptors.response.use(response => {
    // console.log(response);
    return response;
})

// axios#get(url[, config])
export function get(url, config) {
    return request.get(url, config);
}

// axios#post(url[, data[, config]])
export function post(url, data, config) {
    return request.post(url, data, config);
}

export default request
